import Slide from './Slide';

export * from './Slide';
export default Slide;
